import { KeyValue } from '@angular/common';
import { Component, inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ALUMNO_GAUDE_DATALIST_NAME } from '../../../model/contants/datalists';
import { AppStore, SnackbarWarningAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { UdeuService } from '../../../services/udeu.service';
import { Student, GaudeStudent } from '../../../model/classes/gaude-student';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Component({
  templateUrl: './create-record-gaude.dialog.html',
  styleUrls: ['./create-record-gaude.dialog.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateRecordGaudeDialogComponent implements OnInit {
  loading: boolean;

  options: Student[] = [];
  student: Student;
  selectedOption: KeyValue<string, string>;

  private _formBuilder = inject(FormBuilder);

  formGroup: FormGroup<any> = this._formBuilder.group({
    search: ['', [Validators.minLength(3)]]
  });

  @ViewChild(MatAutocompleteTrigger) autocompleteTrigger!: MatAutocompleteTrigger;

  constructor(protected store: Store<AppStore>, private udeuService: UdeuService) {}

  ngOnInit(): void {
    this.loading = false;
  }

  async searchStudent(): Promise<void> {
    const valueStudent = this.formGroup.get('search').value;
    if (typeof valueStudent === 'string' && valueStudent.length >= 3) {
      this.loading = true;
      this.student = null;
      this.autocompleteTrigger.closePanel();
      try {
        const results: GaudeStudent = await this.udeuService.getGaudeDataListValues(ALUMNO_GAUDE_DATALIST_NAME, valueStudent);
        this.options = results?.items?.map((student) => {
          return {...student, campustxt: student.campustxt?.trim()}
        });
        if (this.options?.length === 1) {
          this.student = this.options[0];
          this.formGroup.get('search').setValue(this.student);
        } else {
          this.autocompleteTrigger.openPanel();
        }
      } catch (err) {
        console.error(err);
        this.store.dispatch(new SnackbarWarningAction('No se pudo obtener alumnos.'));
      } finally {
        this.loading = false;
      }
    } else if (valueStudent.length < 3) {
      throw new Error('Method not implemented.');
    }
  }

  displayFn(student: Student): string {
    return student ? `${student.campustxt ? student.campustxt + ': ' : ''}${student.identificativo} - ${student.nombre} ${student.apellido1} ${student.apellido2}` : '';
  }

  selectStudent(student: Student): void {
    this.student = student;
    this.formGroup.get('search').setValue(student);
  }

}